export default __webpack_public_path__ + "0c1542a15ff04881ceef805f2e09ac67.svg";